<template>
  <div class="row h-100 ">
    <div class="login m-auto">

      <div class="card" v-if="stepper">

        <img src="../../assets/4pa_logo_purple.png" class="login-logo"/>

        <div class="card-body pb-0">

          <p>Welcome to the <strong>4Password Authenticators</strong> first-time setup wizard!</p>
          <p>No settings or offline mode detected. Feel free to follow the
            configuration wizard below. <span v-if="!loggedIn">Alternatively, you can switch to <a href="#"
                                                                                                   @click="toggleStepper">Manual
              mode</a>.</span></p>
          <hr class="mb-0"/>
        </div>

        <ul class="stepper stepper-vertical">

          <!-- First Step -->
          <li class="" :class="{'active': step === 1, 'completed': step > 1}">
            <a href="#!" @click="setStep(1)">
              <span class="circle">1</span>
              <span class="label">SecretServer</span>
            </a><!-- Section Description -->
            <div class="step-content" v-if="step == 1">
              <p>From which secure URL can we reach your <strong>Secret Server</strong>? Toggling remember
                will store
                your those credentials for the next time you use 4PA Authenticators.</p>


              <div class="form-group row">
                <label for="url" class="col-form-label col">Secret Server URL<sup>*</sup></label>
                <div class="col-8">

                  <input required type="text" class="form-control" id="url"
                         placeholder="Enter Secret Server url"
                         :disabled="loggedIn"
                         v-model="form.url">
                  <div class="custom-control custom-checkbox float-right">
                    <input type="checkbox" class="custom-control-input" id="remember_url"
                           :disabled="loggedIn"
                           v-model="rememberUrl">
                    <label class="custom-control-label"
                           for="remember_url">remember</label>
                  </div>
                </div>
              </div>
              <hr/>
              <div class="form-group row">

                <label for="domain" class="col-form-label col">User Domain
                </label>

                <div class="col-8">
                  <input type="text" class="form-control" id="domain" :disabled="loggedIn"
                         v-model.trim="form.domain">
                  <div class="custom-control custom-checkbox float-right">
                    <input type="checkbox" class="custom-control-input" id="remember_domain"
                           :disabled="loggedIn"
                           v-model="rememberDomain">
                    <label class="custom-control-label"
                           for="remember_domain">remember</label>
                  </div>
                </div>
              </div>
              <p>User Domain is optional, but required if your custom configuration requires it. If
                available, it iss
                normally found just below the normal login form.</p>
              <button type="button" :disabled="(this.form.url === '')"
                      @click="setStep(2)"
                      class="btn float-right purple darken-4 white-text px-5 z-depth-1">
                Next step
              </button>
            </div>
          </li>

          <!-- Second Step -->
          <li class="" :class="{'active': step === 2, 'completed': step > 2}">
            <a href="#!" @click="setStep(2)">
              <span class="circle">2</span>
              <span class="label">User Credentials</span>
            </a><!-- Section Description -->
            <div class="step-content" v-if="step == 2">

              <div class="alert alert-info" v-if="loggedIn">
                You are logged in, continue with the next steps.
              </div>

              <p>Please login to continue to your authenticators.</p>
              <feedback></feedback>
              <div class="form-group row">
                <label for="username" class="col-form-label col">Username*</label>
                <div class="col-8">

                  <input required type="text" class="form-control" id="username" :disabled="loggedIn"
                         v-model="form.username">
                  <div class="custom-control custom-checkbox float-right">
                    <input type="checkbox" class="custom-control-input" id="remember_user"
                           :disabled="loggedIn"
                           v-model="rememberUser">
                    <label class="custom-control-label"
                           for="remember_user">remember</label>
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="password" class="col-form-label col">Password*</label>
                <div class="col-8">
                  <input required type="password" class="form-control" id="password"
                         :disabled="loggedIn"
                         v-model="form.password">
                </div>
              </div>

              <hr class="my-4"/>
              <p>Authenticator code is required if your account uses an Authenticator or a One Time
                Password. Leave it
                blank otherwise.</p>

              <div class="form-group row mb-4">
                <label for="password" class="col-form-label col">Authenticator code
                </label>
                <div class="col-8">

                  <input type="password" class="form-control" id="otp" :disabled="loggedIn"
                         @keyup.enter.prevent="wizardLogin"
                         v-model.trim="form.OTP">
                </div>
              </div>

              <button type="button"
                      :disabled="(this.form.url === '' || this.form.user === '' || this.form.password === '')"
                      @click="wizardLogin"
                      class="btn float-right purple darken-4 white-text px-5 z-depth-1">
                Login
              </button>
            </div>
          </li>

          <!-- Third Step -->
          <li class="" :class="{'active': step === 3, 'completed': step > 3}">
            <a href="#!" @click="setStep(3)">
              <span class="circle">3</span>
              <span class="label">4PA Settings</span>
            </a><!-- Section Description -->
            <div class="step-content" v-if="step == 3">
              <p>You're now logged in. <br>
                Almost done, 4PA needs to configure which template can be retrieved for authenticators.
              </p>
              <div class="alert alert-info" v-if="preferences === false">
                Fetching user preferences..
              </div>

              <div class="alert alert-info" v-if="preferences == 1">
                No user preferences found, checking for company preferences..
              </div>

              <div v-if="preferences == 3">

                <div class="alert alert-success">
                  User preferences found and loaded, no configuration remaining.
                </div>


                <router-link replace :to="{name: 'authenticators'}" v-if="okey"
                             class="btn float-right purple darken-4 white-text py-2 px-4 z-depth-1">
                  To authenticators
                </router-link>

                <button type="button" v-if="!okey"
                        @click="setStep(4)"
                        class="btn float-right purple darken-4 white-text px-5 z-depth-1">
                  Next step
                </button>
              </div>

              <div v-if="preferences == 4">

                <div class="alert alert-success">
                  Company references found and loaded, almost done.
                </div>

                <button type="button"
                        @click="setStep(4)"
                        class="btn float-right purple darken-4 white-text px-5 z-depth-1">
                  Next step
                </button>
              </div>


              <div class="settings-form" v-if="preferences === 2 || preferences === 0">

                <div class="alert alert-warning">
                  No preferences found, manual configuration required.
                </div>

                <p>Need help
                  <a href="#" @click="showHelp" class="d-inline p-0">how to configure secret
                    server</a>
                  ?
                </p>

                <div class="form-group pb-2">

                  <label for="template_id">Authenticator template id</label>

                  <input type="number" min="0" step="1" class="form-control" id="template_id"
                         v-model="newTemplateId"
                         :disabled="preferences == 3">

                </div>
                <button type="button"
                        @click="storeTemplateId"
                        class="btn float-right purple darken-4 white-text px-5 z-depth-1">
                  Next step
                </button>
              </div>
            </div>
          </li>

          <li v-if="!okey" class="" :class="{'active': step === 4, 'completed': step > 4}">
            <a href="#!" @click="setStep(4)">
              <span class="circle">4</span>
              <span class="label">Offline mode</span>
            </a><!-- Section Description -->
            <div class="step-content" v-if="step == 4">
              <p>4PA Authenticator's can be used without an active internet connection. This is optional
                and requires
                you to create an offline passphrase. This passphrase is used to encrypt your data
                locally.</p>

              <div class="okey-form">
                <p>
                  If disabled, your session is limited to 20 minutes and you will be logged out after
                  expiration.</p>

                <div class="form-group pb-2">
                  <label for="offline_key">Offline passphrase</label>
                  <div class="input-group z-depth-1">
                    <input type="password" class="form-control" id="offline_key"
                           @keyup.enter.prevent="storeNewEncryptKey"
                           v-model="newKey">
                    <div class="input-group-append">
                      <button class="btn purple darken-4 white-text" type="button"
                              id="button-addon2" @click="storeNewEncryptKey">
                        Enable offline mode
                      </button>
                    </div>
                  </div>
                </div>

                <p class="text-muted">
                  Please note, whilst in offline mode it is not possible to retrieve new data without
                  going online
                  first.</p>
              </div>

              <router-link :to="{name: 'authenticators'}" replace
                           class="btn float-right btn-outline-dark p-2 px-4">
                Continue as online-only session
              </router-link>
            </div>
          </li>

        </ul>
      </div>

      <div class="card" v-if="!stepper">

        <img src="../../assets/4pa_logo_purple.png" class="login-logo"/>

        <form v-if="!showOtp && !showOffline" class="card-body">

          <p class="text-center">Login to continue to your <strong>4Passwords Authenticators</strong>.<br/>
            Use the <a href="#" @click="toggleStepper">configuration
              wizard</a>.</p>

          <hr class="mx-4 mt-0">
          <feedback class="mb-4"></feedback>

          <div class="form-group row">
            <label for="url" class="col-form-label col">Secret Server URL<sup>*</sup></label>
            <div class="col-8">

              <input required type="text" class="form-control" id="url"
                     placeholder="Enter Secret Server url"
                     v-model="form.url">
              <div class="custom-control custom-checkbox float-right">
                <input type="checkbox" class="custom-control-input" id="remember_url"
                       v-model="rememberUrl">
                <label class="custom-control-label"
                       for="remember_url">remember</label>
              </div>
            </div>
          </div>

          <div class="form-group row">
            <label for="username" class="col-form-label col">Username*</label>
            <div class="col-8">

              <input required type="text" class="form-control" id="username"
                     v-model="form.username">
              <div class="custom-control custom-checkbox float-right">
                <input type="checkbox" class="custom-control-input" id="remember_user"
                       v-model="rememberUser">
                <label class="custom-control-label"
                       for="remember_user">remember</label>
              </div>
            </div>
          </div>

          <div class="form-group row">
            <label for="password" class="col-form-label col">Password*</label>
            <div class="col-8">
              <input required type="password" class="form-control" id="password"
                     v-model="form.password">
            </div>
          </div>

          <hr class="my-4"/>

          <div class="form-group row mb-4">
            <label for="password" class="col-form-label col">Authenticator code
            </label>
            <div class="col-8">

              <input type="password" class="form-control" id="otp"
                     v-model.trim="form.OTP">
            </div>
          </div>

          <div class="form-group row">

            <label for="domain" class="col-form-label col">User Domain
            </label>

            <div class="col-8">
              <input type="text" class="form-control" id="domain"
                     v-model.trim="form.domain">
              <div class="custom-control custom-checkbox float-right">
                <input type="checkbox" class="custom-control-input" id="remember_domain"
                       v-model="rememberDomain">
                <label class="custom-control-label"
                       for="remember_domain">remember</label>
              </div>
            </div>
          </div>

          <div class="text-center mt-4">
            <button :disabled="isLoading" type="submit"
                    class="btn float-right purple darken-4 white-text px-5 z-depth-1"
                    @click.prevent="post(form)">Login
            </button>
          </div>
        </form>

        <form v-if="showOtp" class="card-body">
          <h3 class="dark-grey-text card-title">OTP</h3>
          <p>This account has an Authenticator enabled, please enter it to confirm the log in.</p>
          <div class="form-group row">
            <label for="password">OTP</label>
            <input type="password" class="form-control" id="otp" placeholder="Enter password"
                   v-model.trim="form.OTP">
          </div>
          <div class="text-center">
            <button :disabled="isLoading" type="submit" class="btn btn-primary btn-block"
                    @click.prevent="post(form)">Login
            </button>
          </div>
        </form>
        <form v-if="showOffline" class="card-body">

          <p class="text-center"><strong>4Passwords authenticators </strong></p>
          <button type="button" class="btn btn-outline-secondary ml-2 float-right"
                  @click="deleteOfflineStore">&times; Clear Offline Data
          </button>
          <h3 class="dark-grey-text card-title mb-4">Offline-mode</h3>

          <p><strong>Offline encrypted storage</strong> detected, enter your passphrase to continue.
          </p>


          <hr/>

          <div class="d-flex flex-column">

            <feedback></feedback>

            <div class="form-group row">
              <label class="col col-form-label" for="offline_key">Offline passphrase</label>

              <div class="col-8">

                <input type="password" class="form-control" id="offline_key"
                       placeholder="Enter offline passphrase"
                       @keyup.enter.prevent="parseOkey"
                       v-model="offlineKey">
              </div>
            </div>
            <button :disabled="isLoading" type="submit"
                    class="ml-auto btn purple darken-4 white-text px-5 z-depth-1"
                    @click.prevent="parseOkey">
              Unlock
            </button>

          </div>

          <hr/>

          <p class="mb-0"><a href="#"
                             @click.prevent="showLogin">Login</a>
            for online mode.</p>


        </form>
      </div>

      <div class="p-4 d-flex justify-content-between">

        <a href="#" class="btn-link purple-text darken" @click="showPrivacy">
          Privacy Policy
        </a>
        <a href="#" class="btn-link purple-text darken" @click="showDisclaimer">
          Disclaimer
        </a>
        <a href="#" class="btn-link purple-text darken" @click="showHelp">
          Help
        </a>
      </div>
      <div class="d-flex justify-content-center mb-2">
        <small>v{{version}}</small>
      </div>

    </div>
  </div>
</template>

<script>
  import EventHub from '../../events/event-hub';
  import {mapActions, mapGetters} from 'vuex';
  import Feedback from '../Feedback';
  import Settings from './_Settings';
  import SettingsIcon from "vue-material-design-icons/Settings";
  import CryptoJS from "crypto-js";

  import * as Toastr from 'toastr';

  Toastr.options.timeout = 1500;

  let keySize = 256;
  let iterations = 100;

  export default {
    name: 'login',
    components: {
      Feedback,
      Settings,
      SettingsIcon,
    },
    data() {
      return {
        short: false,
        stepper: false,
        step: 1,
        form: {
          url: '',
          username: '',
          password: '',
          OTP: '',
          domain: '',
        },
        newTemplateId: false,
        showOtp: false,
        showOffline: false,
        newKey: '',
        offlineKey: '',
        rememberUrl: true,
        rememberUser: true,
        rememberDomain: true,
        preferences: false,
      };
    },
    computed: {
      ...mapGetters({
        isLoading: 'loading/isLoading',
        loggedIn: 'auth/loggedin',
        storeOffline: 'settings/storeOffline',
        templateId: 'authenticators/templateId',
        okey: 'settings/okey',
      }),
      version() {
        return process.env.PACKAGE_JSON;
      }
    },
    methods: {
      ...mapActions({
        setFeedback: 'feedback/setFeedback',
        setDelayedFeedback: 'feedback/setDelayedFeedback',
        setDomain: 'settings/setDomain',
        login: 'auth/login',
        getPreferences: 'authenticators/getPreferences',
        getCompanyPreferences: 'authenticators/getCompanyPreferences',
      }),
      showHelp() {
        EventHub.$emit('help-show');
      },
      showDisclaimer() {
        EventHub.$emit('disclaimer-show');
      },
      showPrivacy() {
        EventHub.$emit('privacy-show');
      },
      storeNewEncryptKey() {
        if (this.newKey !== '') {
          // let key = this.encrypt(this.form.newKey, this.form.newKey);
          this.$store.commit('settings/setStoreOffline', true);
          this.$store.commit('settings/encryptOkey', this.newKey);
          this.offlineKey = '';
          this.$router.replace({name: 'authenticators'});
          Toastr.success('Storing encrypted data offline is enabled.');
        }
      },
      toggleStepper() {
        this.stepper = !this.stepper;
      },
      setStep(i) {
        if (i == 4 && this.loggedIn && this.okey) {
          this.$router.replace({name: 'authenticators'});
        }
        if (i >= 3 && !this.loggedIn) {
          // Login form
          this.setFeedback({
            message: 'Please login first.',
            type: 'info'
          });
          this.step = 2;
        } else {
          this.step = i;
          // if (i == 4 && this.okey !== null && this.okey !== '') {
          //   this.$router.replace({name: 'authenticators'});
          // }
        }
      },
      storeTemplateId() {
        if (this.preferences !== 3 && this.newTemplateId !== null && this.newTemplateId !== '') {
          this.$store.commit('authenticators/setTemplateId', this.newTemplateId);
        }
        this.setStep(4);
      },
      processRemembers() {
        this.$store.commit('auth/setUrl', this.form.url);
        if (this.rememberUrl) {
          localStorage.setItem('url', this.form.url);
        } else {
          localStorage.removeItem('url');
        }
        if (this.rememberUser) {
          localStorage.setItem('user', this.form.username);
        } else {
          localStorage.removeItem('user');
        }
        if (this.rememberDomain) {
          localStorage.setItem('domain', this.form.domain);
        } else {
          localStorage.removeItem('domain');
        }
      },
      wizardLogin() {

        if (this.form.password == '') return;
        this.processRemembers();

        this.login({form: this.form})
          .then(() => {

            this.setStep(3);

            this.getPreferences(true)
              .then(resp => {

                this.preferences = resp;

                if (resp == 0) {
                  return this.getCompanyPreferences()
                    .then(resp => {
                      this.preferences = resp;
                    });
                }
              })
              .finally(() => {

                this.newTemplateId = this.templateId;
              })
            ;
          })
          .catch(error => {
            if (error.data) {

              this.form.OTP = '';
              switch (error.data.error) {
                default:
                  this.setFeedback({message: error.data.error, type: 'warning'});
                  break;
                case "Invalid Google Authenticator pin code.":
                  this.setFeedback({
                    feedback: {
                      message: 'The OTP is incorrect.',
                      type: 'info'
                    }
                  });
                  break;
              }
            }
          });
      },
      post() {
        if (this.form.password == '') return;
        this.processRemembers();

        this.login({form: this.form})
          .then(() => {
            // this.form.password = "";

            this.$router.replace({path: '/'});

          })
          .catch(error => {
            if (error.data) {

              this.form.OTP = '';
              switch (error.data.error) {
                default:
                  this.setFeedback({message: error.data.error, type: 'warning'});
                  this.showLogin();
                  document.getElementById('password')
                    .focus();
                  break;
                case "Invalid Google Authenticator pin code.":
                  this.otp();
                  break;
              }
            }
          });

      },
      deleteOfflineStore() {
        if (confirm("Do you want to remove your offline data?")) { // eslint-disable-line no-alert
          localStorage.removeItem('store');
          this.showLogin();
        }
      },
      showLogin() {
        this.showOffline = false;
        this.showOtp = false;
      },
      otp() {
        this.showOffline = false;
        this.showOtp = true;
      },
      decrypt(transitmessage, pass) {
        let domain = false;
        if (this.form.domain !== "") {
          domain = this.form.domain.toLowerCase();
        }
        let sha = CryptoJS.SHA512(pass + domain)
          .toString(CryptoJS.enc.Hex);
        var salt = CryptoJS.enc.Hex.parse(transitmessage.substr(0, 32));
        var iv = CryptoJS.enc.Hex.parse(transitmessage.substr(32, 32));
        var encrypted = transitmessage.substring(64);

        var key = CryptoJS.PBKDF2(sha, salt, {
          keySize: keySize / 32,
          iterations
        });

        var decrypted = CryptoJS.AES.decrypt(encrypted, key, {
          iv,
          padding: CryptoJS.pad.Pkcs7,
          mode: CryptoJS.mode.CBC

        });
        return decrypted;
      },
      parseOkey() {
        let storedData = localStorage.getItem('store');
        let success = false;
        let stored = false;
        if (storedData) {
          try {
            stored = JSON.parse(this.decrypt(storedData, this.offlineKey)
              .toString(CryptoJS.enc.Utf8));

            if (stored.authenticators) {
              success = true;
            }
          } catch (err) {
          }
        }
        if (success) {
          Promise.all([
            this.$store.commit('loading/setAppLoading', true),
            this.$store.commit('auth/loadOffline', stored.auth),
            this.$store.commit('settings/loadOffline', stored.settings),
            this.$store.commit('authenticators/loadOffline', stored.authenticators),
            this.$store.commit('secretTemplates/loadOffline', stored.secretTemplates),
          ])
            .then(() => {
              this.$store.dispatch('auth/authenticate')
                .then(() => {
                  this.$router.replace({path: '/'});
                  this.$store.commit('loading/setAppLoading', false);
                })
                .catch(() => {
                  this.$router.replace({path: '/'});
                  this.$store.commit('auth/setOfflineMode', true);
                  this.$store.commit('loading/setAppLoading', false);
                });
            });
        } else {
          this.setFeedback({message: 'Sorry, the offline passphrase is incorrect.', type: 'warning'});
        }
      },
      parseOffline() {
        let storedData = localStorage.getItem('store');
        if (storedData) {
          try {
            let dec = CryptoJS.AES.decrypt(storedData, this.offlineKey)
              .toString(CryptoJS.enc.Latin1);
            let stored = JSON.parse(dec);

            if (stored.authenticators) {
              this.$store.commit('authenticators/loadOffline', stored.authenticators)
                .then(() => {
                  this.$router.replace({path: '/'});
                });
            }
          } catch (err) {
            localStorage.removeItem('store');
          }
        }
      }
    },
    mounted() {
      const url = localStorage.getItem('url');
      if (url !== null && url !== 'undefined') {
        this.form.url = url;
        this.rememberUrl = true;
      }
      const user = localStorage.getItem('user');
      if (user !== null && user !== 'undefined') {
        this.form.username = user;
        this.rememberUser = true;
      }
      const domain = localStorage.getItem('domain');
      if (domain !== null && domain !== 'undefined') {
        this.form.domain = domain;
        this.rememberDomain = true;
      }
      if (localStorage.getItem('store')) {
        if (this.loggedIn) {
          this.setDelayedFeedback({
            message: 'Offline store detected, logging in will preserve the predefined offline-key.',
            type: 'warning'
          });
        } else {
          this.showOffline = true;
        }
      }
      const stepper = localStorage.getItem('stepper');
      if (this.form.domain === "" && stepper !== false) {
        this.step = 1;
        this.stepper = true;
      }
      if (this.$route.query.in && this.$route.query.in == 1) {
        this.showOffline = false;
      }
    },
    beforeDestroy() {
      this.form.username = '';
      this.form.password = '';
      this.form.otp = '';
      this.offlineKey = '';
    },
  };
</script>




// WEBPACK FOOTER //
// src/components/pages/Login.vue